module.exports = require('./dist/emotion')



//////////////////
// WEBPACK FOOTER
// ../node_modules/system-components/emotion.js
// module id = 305
// module chunks = 0